import {z} from "zod";

import {normalizeUsPhoneDigits} from "@/src/modules/properties/lib/us-phone";

import {roleRequiresDispatchCenter} from "../lib/dispatch-center-assignment";

export const roleSchema = z.object({
  id: z.number(),
  name: z.string(),
  without_property: z.enum(["required", "optional", "all", "forbidden"]),
  multiple_properties: z.number(),
  // permissions: z.array(z.string()),
});

export const propertySchema = z.object({
  id: z.number(),
  name: z.string(),
});

export const dispatchCenterOptionSchema = z.object({
  id: z.number(),
  name: z.string(),
  type: z.enum(["internal", "third_party"]).optional(),
  status: z.union([z.literal(0), z.literal(1)]).optional(),
});

export const userSchema = z
  .object({
    user_id: z.number().optional(),
    first_name: z.string().min(2, {message: "First name must be at least 2 characters"}),
    last_name: z.string().min(2, {message: "Last name must be at least 2 characters"}),
    user_name: z.string().min(2, {message: "User name must be at least 2 characters"}),

    telephone: z.string().optional(),
    emergency_contact_name: z
      .string()
      .max(255, {message: "Emergency contact name must be at most 255 characters"})
      .nullable()
      .optional(),
    emergency_contact_phone: z
      .string()
      .max(20, {message: "Emergency contact phone must be at most 20 characters"})
      .nullable()
      .optional(),
    email: z.string().email({message: "Invalid email address"}),
    role: roleSchema,
    dispatch_center: dispatchCenterOptionSchema.nullable().optional(),

    properties: z.array(propertySchema).or(propertySchema),
  })
  .superRefine((data, ctx) => {
    if (!data.role) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Role is required",
        path: ["role"],
      });
    }

    const telephoneDigits = normalizeUsPhoneDigits(data.telephone ?? "");
    if (telephoneDigits.length > 0 && telephoneDigits.length !== 10) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Telephone must be 10 digits when provided",
        path: ["telephone"],
      });
    }

    const emergencyPhoneDigits = normalizeUsPhoneDigits(data.emergency_contact_phone ?? "");
    if (emergencyPhoneDigits.length > 0 && emergencyPhoneDigits.length !== 10) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Emergency contact phone must be 10 digits when provided",
        path: ["emergency_contact_phone"],
      });
    }

    if (roleRequiresDispatchCenter(data.role) && !data.dispatch_center?.id) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Dispatch center is required",
        path: ["dispatch_center"],
      });
    }
  });
